import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import NavBack from 'dashboard/components/NavBack';
import { FullScreenHeaderContainer } from 'dashboard/layouts/ShowViewLayoutV2';
import { Team } from 'dashboard/models/team';
import { User } from 'dashboard/models/user';
import MemberListPanel from 'dashboard/views/DashboardTeamShowView/MemberListPanel';
import Card from 'design-system/components/Card';
import { Label, Span } from 'design-system/components/Text';

const TeamModulesWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-column-gap: ${Spacing[5]};
  padding: ${Spacing[7]};
`;

const HorizontalContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TableTitleContainer = styled('div')`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: ${Spacing[2]};
`;

export interface TeamDetailsProps {
  userIdToRoleNames: Record<string, string[]>;
  users: User[];
  team: Team;
  teamUserIds: string[];
}

const TeamDetails = ({ userIdToRoleNames, team, teamUserIds, users }: TeamDetailsProps) => {
  return (
    <>
      <FullScreenHeaderContainer>
        <HorizontalContainer>
          <NavBack to='/dashboard/teams' />
          <Span>All teams</Span>
        </HorizontalContainer>
      </FullScreenHeaderContainer>
      <TeamModulesWrapper>
        <Card>
          <Card.Body>
            <MemberListPanel
              userIdToRoleNames={userIdToRoleNames}
              teamUserIds={teamUserIds}
              users={users}
            />
          </Card.Body>
        </Card>
        <div>
          <Card>
            <Card.Body>
              <TableTitleContainer>
                <Card.Title>Summary</Card.Title>
              </TableTitleContainer>
              <Label size='md' weight='bold'>
                Team name
              </Label>
              <Span>{team.attributes.name}</Span>
            </Card.Body>
          </Card>
        </div>
      </TeamModulesWrapper>
    </>
  );
};

export default TeamDetails;
